import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Text, Stack } from "@mantine/core";
// import iconPromotion from "../images/discount.png";
// import iconAbout from "../images/about.png";
import ListNotificationsLayout from "./ListNotificationsLayout";
import ItemLayout from "../items/ItemLayout";
import { useGetNotificationStickyQuery } from "@/services/notificationAPI";
import { NsType } from "@/dto/notifications/response/enum";
import { parseTimeAndDate } from "@/utils/common";

interface NotificationListPromotionProps {
  openNotificationDetail: () => void;
  activeDrawer?: any;
  setActiveDrawer?: any;
}

const NotificationListPromotion = ({
  openNotificationDetail,
  activeDrawer,
  setActiveDrawer,
}: NotificationListPromotionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data } = useGetNotificationStickyQuery({
    nsType: NsType.PromoSystem,
  });
  return (
    <Stack spacing={0}>
      {(data?.body?.news ?? data?.body?.privateNotifications ?? []).map((item) => {
        const { time, date } = parseTimeAndDate(item.startTime);

        return (
          <ListNotificationsLayout
            title={
              <Text weight={600} size={14} color="#111827">
                {date}
              </Text>
            }
            content={
              <ItemLayout
                style={{ backgroundColor: "#FDFDFD" }}
                title={item.title}
                content={item.description}
                bottom={
                  <Text size={12} color="#9CA3AF">
                    {time}
                  </Text>
                }
              />
              // <>
              //   <ItemLayout
              //     onClick={() => setActiveDrawer(NOTIFICATION_DETAIL)}
              //     style={{ backgroundColor: "#E5F4FE" }}
              //     title={
              //       <Group spacing={12} mb={10} align="center">
              //         <Box
              //           sx={{
              //             display: "flex",
              //             alignItems: "center",
              //             width: "24px",
              //             height: "24px",
              //           }}
              //         >
              //           <Image src={iconPromotion} fit="contain" />
              //         </Box>
              //         <Text size={14} weight={600} color="#111827">
              //           {t("PROMOTION_NOTI")}
              //         </Text>
              //       </Group>
              //     }
              //     content={
              //       <Text sx={{ color: "#131618" }}>
              //         This service package includes all the necessary banking
              //         services for your business, so you dont need to subscribe to
              //         multiple individual servic...
              //       </Text>
              //     }
              //     bottom={
              //       <Group position="apart" mt={10}>
              //         <Text size={12} color="#9CA3AF">
              //           09:20
              //         </Text>
              //       </Group>
              //     }
              //   />
              //   <ItemLayout
              //     style={{ backgroundColor: "#FDFDFD" }}
              //     title={
              //       <Group spacing={12} mb={10}>
              //         <Box sx={{ width: "24px", height: "24px" }}>
              //           <Image src={iconAbout} fit="contain" />
              //         </Box>
              //         <Text size={14} weight={600} color="#111827">
              //           {t("SYSTEM_ANNOUNCEMENT")}
              //         </Text>
              //       </Group>
              //     }
              //     content={
              //       <Text sx={{ color: "#131618" }}>
              //         This service package includes all the necessary banking
              //         services for your business, so you dont need to subscribe to
              //         multiple individual servic...
              //       </Text>
              //     }
              //     bottom={
              //       <Group position="apart" mt={10}>
              //         <Text size={12} color="#9CA3AF">
              //           09:20
              //         </Text>
              //       </Group>
              //     }
              //   />
              // </>
            }
          />
        );
      })}

      {/* <ListNotificationsLayout
        title={
          <Text weight={600} size={14} color="#111827">
            28/07/2023
          </Text>
        }
        content={
          <ItemLayout
            style={{ backgroundColor: "#E5F4FE" }}
            title={
              <Group spacing={12} mb={10} align="center">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "24px",
                    height: "24px",
                  }}
                >
                  <Image src={iconPromotion} fit="contain" />
                </Box>
                <Text size={14} weight={600} color="#111827">
                  {t("PROMOTION_NOTI")}
                </Text>
              </Group>
            }
            content={
              <Text sx={{ color: "#131618" }}>
                This service package includes all the necessary banking services
                for your business, so you dont need to subscribe to multiple
                individual servic...
              </Text>
            }
            bottom={
              <Group position="apart" mt={10}>
                <Text size={12} color="#9CA3AF">
                  09:20
                </Text>
              </Group>
            }
          />
        }
      /> */}
    </Stack>
  );
};

export default NotificationListPromotion;
